<template>
  <div
    class="content-chip"
    :class="[{yellow:yellow,narrow:narrow,red:red,lightGray:lightGray,orange:orange,darkGray:darkGray,green:green,mediumBlue:mediumBlue,bold:bold},color]"
  >
    <i
      v-if="leadingIcon"
      class="thumbnail"
      :class="leadingIcon"
    />
    <img
      v-if="leadingImg"
      :src="leadingImg"
      alt=""
      class="leadingImg"
    >
    <p
      v-if="textLabel"
      class="text"
      :class="{'no-wrap': noWrap}"
    >
      {{ isI18n ? $t(textLabel) : textLabel }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ContentChip",
  props: {
    leadingIcon: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    leadingImg: {
      type: String,
      default: "",
    },
    yellow: {
      type: Boolean,
      default: false,
    },
    orange: {
      type: Boolean,
      default: false,
    },
    lightGray: {
      type: Boolean,
      default: false,
    },
    darkGray: {
      type: Boolean,
      default: false,
    },
    mediumBlue: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
    green: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    bold: {
      type: Boolean,
      default: false,
    },
    noWrap: {
      type: Boolean,
      default: false,
    },
    isI18n: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({}),
};
</script>

<style lang="scss">
@import "@/assets/scss/component/content-chip";
</style>